<template>
  <div>
    <form>
      <div v-if="loginError" class="alert alert-danger" role="alert">
        {{ loginErrorMessage }}
      </div>
      <div class="form-group">
        <label for="email">Email address</label>
        <input type="email" name="email" class="form-control form-control-lg" placeholder="Email"
              v-model="email" v-validate="'required|email'" v-on:keyup="keyCheck">
        <span v-show="errors.has('email')" class="input-error">Please enter a valid email address.</span>
      </div>
      <div class="form-group">
        <label for="password">Password</label>
        <input type="password" name="password" class="form-control form-control-lg" v-model="password"
               placeholder="Password" v-validate="'required'" v-on:keyup="keyCheck">
        <span v-show="errors.has('password')" class="input-error">{{ errors.first('password') }}</span>
      </div>

      <p class="text-lg-right">
        <router-link to="/forgot-password" style="color: #007bff;">
          Forgot Password
        </router-link>
      </p>

      <button type="button" class="btn btn-primary btn-lg" v-on:click="validate()">
        Sign In
      </button>
    </form>

    <hr v-show="false" class="hr-text" data-content="Or login with social media"/>

    <div v-show="false" class="socal-login-buttons" align="center">
      <a href="javascript:;" class="btn btn-social btn-block btn-facebook">
        <i class="icon fa fa-facebook"></i> Continue with Facebook
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignIn',
  data: function () {
    return {
      loginError: false,
      loginErrorMessage: null,
      email: null,
      password: null
    }
  },
  methods: {
    keyCheck: function (event) {
      if (event.keyCode === 13) {
        this.login()
      }
    },
    validate () {
      var self = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          self.login()
        }
      })
    },
    login: function () {
      var self = this
      this.error = false

      this.$http.post('authenticate', { email: this.email, password: this.password }).then(function (response) {
        var results = response.data

        self.$localStorage.set('apikey', results.auth_token)
        self.$localStorage.set('user_type', results.user_type)
        self.$localStorage.set('user_reference', results.user_reference)
        self.$localStorage.set('user_first_name', results.first_name)
        self.$localStorage.set('user_last_name', results.last_name)
        self.$localStorage.set('user_full_name', results.full_name)
        self.$localStorage.set('user_email', results.email)
        self.$localStorage.set('user_stripe_acocunt_reference', results.stripe_account_reference)

        self.$store.commit('updateUserType', results.user_type)

        self.$root.logged = true
        self.$router.push({ name: 'home',
          params: {
            loginSuccessfully: true
          }
        })
      }).catch(function (error) {
        var errorList = ''

        if (error) {
          self.loginError = true
          errorList = error.response.data.error.user_authentication.join(', ')
        }

        self.loginErrorMessage = errorList = errorList.charAt(0).toUpperCase() + errorList.slice(1)
      })
    }
  }
}
</script>
